import useAuth from '@hooks/useAuth';
import { notification } from 'antd';
import { useEffect, useState } from 'react';
import api from '../services/api';
import { getClientFileUrl } from './getClientFileUrl';
import { sendClientData } from './sendClientData';

interface IClientsProps {
  agreementType: string;
  agreementID: number;
}

interface IUrlClientData {
  LS_ISN: string;
  FILE_ISN: string;
  FILE_PATH_STORAGE: string;
}

export interface IClientDataSend {
  ls_isn: string;
  file_isn: string;
  certificateValidityPeriod: string;
  iin: string;
  tspDate: string;
  name: string;
}

function Clients(props: IClientsProps) {
  const [isStatusClient, setIsStatusClient] = useState<boolean>(false);
  const [urlClientData, setUrlClientData] = useState<IUrlClientData[]>([]);
  const [clientDataSend, setClientDataSend] = useState<IClientDataSend[]>([]);

  const auth = useAuth();

  const { agreementID, agreementType } = props;

  useEffect(() => {
    if (agreementType === 'kias' && agreementID) {
      const foreignId = auth.user.data.user_info.foreign_id;
      getClientFileUrl(foreignId, agreementID).then((values) => {
        if (values?.status === true) {
          setIsStatusClient(true);
          setUrlClientData(values?.url);
        }
      });
    }
  }, [agreementType, agreementID]);

  useEffect(() => {
    if (isStatusClient === true && urlClientData.length) {
      processClientSignatures(urlClientData);
    }
  }, [isStatusClient, urlClientData]);

  useEffect(() => {
    const clientDataSendLength = clientDataSend.length;
    const urlClientDataLength = urlClientData.length;
    if (clientDataSendLength > 0 && urlClientDataLength === clientDataSendLength) {
      sendClientData(clientDataSend)
    }
  }, [clientDataSend])

  const normalizeFileUrl = (pathOrUrl: string) => {
    if (!pathOrUrl) return '';
    if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
    return `https://mycent.kz/storage/${pathOrUrl.replace(/^\/+/, '')}`;
  };

  const checkSignedFile = async (url: string, lsIsn: string, fileIsn: string) => {
    const normalizedUrl = normalizeFileUrl(url);
    if (!normalizedUrl) return null;

    try {
      const blob = await fetch(normalizedUrl).then((response) => response.blob());
      const fileName = new URL(normalizedUrl).pathname.split('/').pop() || 'file.cms';
      const file = new File([blob], fileName, { type: blob.type });
      const formData = new FormData();
      formData.append('file', file);

      const { data }: any = await api.checkSignedFile(formData);
      const signInfo = data?.data?.[0];
      if (!signInfo?.iin || !signInfo?.commonName) {
        return null;
      }

      return {
        certificateValidityPeriod: signInfo.certificateValidityPeriod,
        iin: signInfo.iin,
        tspDate: signInfo.tspDate,
        name: signInfo.commonName,
        ls_isn: lsIsn,
        file_isn: fileIsn,
      };
    } catch {
      notification.info({
        message: 'Оповещение',
        description: 'Не удалось проверить подпись клиентского файла.',
      });
      return null;
    }
  };

  const processClientSignatures = async (urls: IUrlClientData[]) => {
    const signatureInfoList = await Promise.all(
      urls.map((element) =>
        checkSignedFile(element.FILE_PATH_STORAGE, element.LS_ISN, element.FILE_ISN)
      )
    );
    const validSignatureInfo = signatureInfoList.filter(Boolean) as IClientDataSend[];
    if (validSignatureInfo.length > 0) {
      setClientDataSend(validSignatureInfo);
    }
  };

  return null;
}

export default Clients;
